export const locationList = [
    { label: "Algeria", value: "algeria" },
    { label: "Angola", value: "angola" },
    { label: "Benin", value: "benin" },
    { label: "Botswana", value: "botswana" },
    { label: "Burkina Faso", value: "burkina-faso" },
    { label: "Burundi", value: "burundi" },
    { label: "Cabo Verde", value: "cabo-verde" },
    { label: "Cameroon", value: "cameroon" },
    { label: "Central African Republic", value: "central-african-republic" },
    { label: "Chad", value: "chad" },
    { label: "Comoros", value: "comoros" },
    { label: "Democratic Republic of the Congo", value: "democratic-republic-of-the-congo" },
    { label: "Republic of the Congo", value: "republic-of-the-congo" },
    { label: "Djibouti", value: "djibouti" },
    { label: "Egypt", value: "egypt" },
    { label: "Equatorial Guinea", value: "equatorial-guinea" },
    { label: "Eritrea", value: "eritrea" },
    { label: "Eswatini", value: "eswatini" },
    { label: "Ethiopia", value: "ethiopia" },
    { label: "Gabon", value: "gabon" },
    { label: "Gambia", value: "gambia" },
    { label: "Ghana", value: "ghana" },
    { label: "Guinea", value: "guinea" },
    { label: "Guinea-Bissau", value: "guinea-bissau" },
    { label: "Ivory Coast (Côte d'Ivoire)", value: "ivory-coast" },
    { label: " Kenya", value: "kenya" }, 
    { label: "Lesotho", value: "lesotho" },
    { label: "Liberia", value: "liberia" },
    { label: "Libya", value: "libya" },
    { label: "Madagascar", value: "madagascar" },
    { label: "Malawi", value: "malawi" },
    { label: "Mali", value: "mali" },
    { label: "Mauritania", value: "mauritania" },
    { label: "Mauritius", value: "mauritius" },
    { label: "Morocco", value: "morocco" },
    { label: "Mozambique", value: "mozambique" },
    { label: "Namibia", value: "namibia" },
    { label: "Niger", value: "niger" },
    { label: "Nigeria", value: "nigeria" },
    { label: "Rwanda", value: "rwanda" },
    { label: "São Tomé and Príncipe", value: "sao-tome-and-principe" },
    { label: "Senegal", value: "senegal" },
    { label: "Seychelles", value: "seychelles" },
    { label: "Sierra Leone", value: "sierra-leone" },
    { label: "Somalia", value: "somalia" },
    { label: "South Africa", value: "south-africa" },
    { label: "South Sudan", value: "south-sudan" },
    { label: "Sudan", value: "sudan" },
    { label: "Tanzania", value: "tanzania" },
    { label: "Togo", value: "togo" },
    { label: "Tunisia", value: "tunisia" },
    { label: "Uganda", value: "uganda" },
    { label: "Zambia", value: "zambia" },
    { label: "Zimbabwe", value: "zimbabwe" }
  ];
  